import { MockSearchCustomerApiResponse, MockSearchCustomerSearchParams } from './formModel';
import { mockCustomerData } from './resultsMock';

export const mockSearchCustomerAPI = async (
  searchValues: MockSearchCustomerSearchParams
): Promise<MockSearchCustomerApiResponse> => {
  const mockData = await new Promise<typeof mockCustomerData>((resolve) => {
    setTimeout(() => resolve(mockCustomerData), 300);
  });
  const allItems = mockData.pages.flat();
  const { pageSize } = mockData;

  const normalize = (value?: string) => (value ?? '').trim().toLowerCase();
  const digitsOnly = (value?: string) => (value ?? '').replace(/\D/g, '');
  const page = searchValues.page ?? 1;

  const search = {
    legalName: normalize(searchValues.legalName),
    email: normalize(searchValues.email),
    countryCode: digitsOnly(searchValues.countryCode),
    mobileNumber: normalize(searchValues.mobileNumber),
  };

  const hasAtLeastOneFilter = Object.values(search).some((value) => value.length > 0);

  if (!hasAtLeastOneFilter) {
    return {
      items: [],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        pageSize,
        totalItems: 0,
      },
    };
  }

  const filteredItems = allItems.filter((item) => {
    const itemValue = {
      legalName: normalize(item.legalName),
      email: normalize(item.email),
      countryCode: digitsOnly(item.countryCode),
      mobileNumber: digitsOnly(item.mobileNumber),
      address: normalize(item.address),
    };

    const legalNameMatches = search.legalName && itemValue.legalName.includes(search.legalName);
    const emailMatches = search.email && itemValue.email.includes(search.email);
    const countryCodeMatches = search.countryCode && itemValue.countryCode === search.countryCode;
    const mobileNumberMatches = search.mobileNumber && itemValue.mobileNumber.includes(search.mobileNumber);

    return legalNameMatches || emailMatches || countryCodeMatches || mobileNumberMatches;
  });

  const totalItems = filteredItems.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const currentPage = Math.min(Math.max(page, 1), totalPages);
  const startIndex = (currentPage - 1) * pageSize;
  const items = filteredItems.slice(startIndex, startIndex + pageSize);

  return {
    items,
    pagination: {
      currentPage,
      totalPages,
      pageSize,
      totalItems,
    },
  };
};
